const createAndConfirmPasswordEn = {
  'createPassword': {
    'passwordLabel': 'Password',
    'confirmPasswordLabel': 'Repeat the password',
    'requirementsTitle': 'Password must contain:',
    'requirements': {
      'symbolsCount': '8 characters',
      'specialCharacters': '1 special character',
      'numbers': '1 digit',
      'letters': 'Russian or Latin letters',
      'lowerAndUpperCase': 'uppercase and lowercase letters',
    },
    'errors': {
      'passwordNotMatch': 'Passwords do not match',
    },
  },
};

export default createAndConfirmPasswordEn;
